import ApiService from "../api";

class ResetService extends ApiService{

    constructor(){
        super('/api')
    }

    resetar(credentials){
        const requestUrl = `/resetar`
        return this.post(requestUrl, credentials);
    }
}

export default ResetService;